import React, { useState } from "react";
import InstitutionNavbar from "../components/instituteNavbar";
import Footer from "../components/Footer";
import ReactSelect from "react-select";
import { useNavigate, useLocation } from "react-router-dom"; // Moved to top
import axios from "axios"; // Moved to top

const qualificationOptions = [
  'NTT (Nursery Teacher Training)',
  'D.El.Ed (Diploma in Elementary Education)',
  'B.Ed (Bachelor of Education)',
  'Integrated Teacher Education Program (ITEP)',
  'Teacher Eligibility Tests (TET/CTET etc.)',
  'Post-Graduation (MA/MSc/MCom)',
  'PhD',
  'NET / SET',
  'Any'
];

const WalkinForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if we are editing
  const isEditMode = location.state?.mode === 'edit';
  const walkinData = location.state?.walkinData;

  const [formData, setFormData] = useState({
    heading: "",
    description: "",
    positions: "",
    min_experience: "",
    max_experience: "",
    prefered_qualifications: [],
    skills: "",
    venue: "",
    date: "",
    time: "",
    documents: "",
    about: "",
    contactName: "",
    phone: "",
    email: "",
  });

  // Pre-fill data if editing
  React.useEffect(() => {
    if (isEditMode && walkinData) {
      setFormData({
        heading: walkinData.heading || "",
        description: walkinData.description || "",
        positions: walkinData.positions || "",
        min_experience: walkinData.min_experience || "",
        max_experience: walkinData.max_experience || "",
        prefered_qualifications: walkinData.prefered_qualifications || [],
        skills: walkinData.skills || "",
        venue: walkinData.venue || "",
        date: walkinData.date ? new Date(walkinData.date).toISOString().split('T')[0] : "",
        time: walkinData.time || "",
        documents: walkinData.documents || "",
        about: walkinData.about || "",
        contactName: walkinData.contact_name || "",
        phone: walkinData.contact_phone || "",
        email: walkinData.contact_email || "",
      });
    }
  }, [isEditMode, walkinData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      prefered_qualifications: formData.prefered_qualifications,
    };

    try {
      const token = localStorage.getItem("token");

      let response;
      if (isEditMode) {
        // UPDATE Existing Walkin
        response = await axios.put(
          `${process.env.REACT_APP_API_URL}/api/institutionfilter/walkin/${walkinData._id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        // CREATE New Walkin
        response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/institutionfilter/walkin`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (response.status === 200 || response.status === 201) {
        alert(isEditMode ? "Walk-In Drive updated successfully." : "Walk-In Recruitment Drive published successfully.");
        navigate('/manage-walkins'); // Redirect to manage page
      } else {
        alert(response.data.message || "Failed to save drive.");
      }
    } catch (error) {
      console.error("Error publishing walkin:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <InstitutionNavbar />

      <div className="page-container form-card mt-[120px]">
        {/* Header */}
        <div className="form-header">
          <h2 className="page-title mb-0">
            {isEditMode ? "Edit Walk-In Recruitment Drive" : "Post New Walk-In Recruitment Drive"}
          </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-grid-2 animate-fadeIn">

            {/* Drive Title */}
            <div className="form-group-full">
              <label className="profile-label">Drive Title</label>
              <input
                type="text"
                name="heading"
                value={formData.heading}
                onChange={handleChange}
                className="profile-input"
                placeholder="Walk-In Hiring Drive for Software Engineers – Bengaluru"
                required
              />
            </div>

            {/* Drive Overview */}
            <div className="form-group-full">
              <label className="profile-label">Drive Overview</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="profile-input min-h-[100px]"
                placeholder="Provide a brief overview of the recruitment drive, including purpose and target candidates."
                required
              />
            </div>

            {/* Roles / Designations */}
            <div className="form-group-full">
              <label className="profile-label">Open Positions / Designations</label>
              <input
                type="text"
                name="positions"
                value={formData.positions}
                onChange={handleChange}
                className="profile-input"
                placeholder="Software Engineer, QA Analyst, Business Analyst"
                required
              />
            </div>

            {/* ===== EXPERIENCE (PostJob Style) ===== */}
            <div className="form-group">
              <label className="profile-label">Minimum Experience (Years)</label>
              <input
                type="number"
                name="min_experience"
                value={formData.min_experience}
                onChange={handleChange}
                className="profile-input"
                placeholder="Min"
                min="0"
                required
              />
            </div>

            <div className="form-group">
              <label className="profile-label">Maximum Experience (Years)</label>
              <input
                type="number"
                name="max_experience"
                value={formData.max_experience}
                onChange={handleChange}
                className="profile-input"
                placeholder="Max"
                min="0"
                required
              />
            </div>

            {/* ===== QUALIFICATION (PostJob Style React-Select) ===== */}
            <div className="form-group-full">
              <label className="profile-label">Preferred Qualifications</label>
              <ReactSelect
                isMulti
                name="prefered_qualifications"
                options={qualificationOptions.map(opt => ({ value: opt, label: opt }))}
                value={
                  Array.isArray(formData.prefered_qualifications)
                    ? formData.prefered_qualifications.map(q => ({ value: q, label: q }))
                    : []
                }
                onChange={(selectedOptions) => {
                  const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                  setFormData(prev => ({ ...prev, prefered_qualifications: values }));
                }}
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '45px',
                    borderColor: '#e5e7eb',
                    boxShadow: 'none',
                    '&:hover': { borderColor: '#3b82f6' }
                  })
                }}
                placeholder="Select Qualifications..."
              />
            </div>

            {/* Skills */}
            <div className="form-group-full">
              <label className="profile-label">Key Skills / Competencies</label>
              <input
                type="text"
                name="skills"
                value={formData.skills}
                onChange={handleChange}
                className="profile-input"
                placeholder="Java, React, SQL, Communication Skills"
                required
              />
            </div>

            {/* Venue */}
            <div className="form-group-full">
              <label className="profile-label">Walk-In Venue (Interview Location)</label>
              <textarea
                name="venue"
                value={formData.venue}
                onChange={handleChange}
                className="profile-input min-h-[80px]"
                placeholder="Full address of the interview location including building name, floor, and landmarks."
                required
              />
            </div>

            {/* Date */}
            <div className="form-group">
              <label className="profile-label">Drive Date</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className="profile-input"
                required
              />
            </div>

            {/* Time */}
            <div className="form-group">
              <label className="profile-label">Reporting Time Window</label>
              <input
                type="text"
                name="time"
                value={formData.time}
                onChange={handleChange}
                className="profile-input"
                placeholder="10:00 AM – 3:00 PM"
                required
              />
            </div>

            {/* Documents */}
            <div className="form-group-full">
              <label className="profile-label">Documents Required at Venue</label>
              <textarea
                name="documents"
                value={formData.documents}
                onChange={handleChange}
                className="profile-input min-h-[80px]"
                placeholder="Updated Resume, Government ID Proof, Academic Certificates"
                required
              />
            </div>

            {/* About Organization */}
            <div className="form-group-full">
              <label className="profile-label">About the Organization</label>
              <textarea
                name="about"
                value={formData.about}
                onChange={handleChange}
                className="profile-input min-h-[80px]"
                placeholder="Brief introduction to your organization and business domain."
                required
              />
            </div>

            {/* Contact Name */}
            <div className="form-group">
              <label className="profile-label">HR / Recruitment Contact Person</label>
              <input
                type="text"
                name="contactName"
                value={formData.contactName}
                onChange={handleChange}
                className="profile-input"
                placeholder="Ananya Sharma"
                required
              />
            </div>

            {/* Phone */}
            <div className="form-group">
              <label className="profile-label">Contact Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="profile-input"
                placeholder="+91 98765 43210"
                required
              />
            </div>

            {/* Email */}
            <div className="form-group-full">
              <label className="profile-label">
                Official Contact Email <span className="text-gray-400 italic">(Optional)</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="profile-input"
                placeholder="careers@company.com"
              />
            </div>

            {/* Submit Button */}
            <div className="md:col-span-2 mt-6">
              <button type="submit" className="btn-primary-pill">
                {isEditMode ? "Update Drive" : "Publish Walk-In Drive"}
              </button>
            </div>

          </div>
        </form>
      </div>

      <Footer />
    </>
  );
};

export default WalkinForm;
